import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
import * as React from 'react';
import { mergeStyles, numberToPrettyString } from '@cian/utils';
import { getFloorPlanPolygonParams } from '../../utils/map/polygon';
import { PolygonsDrawer } from '../polygons_drawer';
import * as styles from './index.css';
import { jsxs as _jsxs } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
var CANVAS_SIZE = [84, 37];
export var SideBlockOfferCard = /*#__PURE__*/function (_React$Component) {
  _inherits(SideBlockOfferCard, _React$Component);
  var _super = _createSuper(SideBlockOfferCard);
  function SideBlockOfferCard() {
    var _this;
    _classCallCheck(this, SideBlockOfferCard);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty(_assertThisInitialized(_this), "getDrawParams", function () {
      return getFloorPlanPolygonParams(CANVAS_SIZE, _this.props.offer.polygons.map(function (polygon) {
        return polygon.points;
      }));
    });
    return _this;
  }
  _createClass(SideBlockOfferCard, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
        offer = _this$props.offer,
        onSelect = _this$props.onSelect,
        isHovered = _this$props.isHovered,
        isSimilarPhase = _this$props.isSimilarPhase,
        onHover = _this$props.onHover;
      var price = offer.price,
        roomsTitle = offer.roomsTitle,
        area = offer.area,
        flatNumber = offer.flatNumber,
        polygons = offer.polygons,
        _offer$floor = offer.floor,
        floor = _offer$floor === void 0 ? 1 : _offer$floor;
      return /*#__PURE__*/_jsxs("li", _objectSpread(_objectSpread({
        id: "offer-card-".concat(flatNumber),
        onClick: function onClick() {
          return onSelect(offer);
        }
      }, mergeStyles([styles['container'], isHovered && styles['container--hovered'], isSimilarPhase && styles['container--similar_phase']])), {}, {
        onMouseEnter: function onMouseEnter() {
          return onHover && onHover(offer.id);
        },
        onMouseLeave: function onMouseLeave() {
          return onHover && onHover();
        },
        children: [/*#__PURE__*/_jsxs("div", {
          className: styles['container-left'],
          children: [/*#__PURE__*/_jsxs("strong", {
            className: styles['title'],
            children: [roomsTitle, " ", area, " \u043C\xB2"]
          }), isSimilarPhase && /*#__PURE__*/_jsxs("span", {
            className: styles['subtitle'],
            children: [floor, " \u044D\u0442\u0430\u0436"]
          }), /*#__PURE__*/_jsxs("span", {
            className: styles['price'],
            children: [numberToPrettyString(price), " \u20BD"]
          })]
        }), /*#__PURE__*/_jsx("div", {
          className: styles['container-right'],
          children: /*#__PURE__*/_jsx(PolygonsDrawer, {
            isSidebar: true,
            autoResize: false,
            container: null,
            containerStyle: styles['floor-preview'],
            polygons: polygons || [],
            defaultColor: "#e4e4e4",
            width: CANVAS_SIZE[0],
            height: CANVAS_SIZE[1],
            backgroundDrawingAlgorythm: this.getDrawParams
          })
        })]
      }));
    }
  }]);
  return SideBlockOfferCard;
}(React.Component);